import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const SubscriptionBreakdown = ({ data, currentLanguage = 'fr' }) => {
  const labels = {
    fr: {
      title: 'Répartition des abonnements',
      total: 'Total'
    },
    ar: {
      title: 'توزيع الاشتراكات',
      total: 'المجموع'
    }
  };

  const COLORS = {
    'Plan Basique': 'var(--color-accent)',
    'Plan Standard': 'var(--color-primary)',
    'Plan Premium': 'var(--color-secondary)',
    'Essai gratuit': 'var(--color-muted)'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-warm-md">
          <p className="font-medium text-foreground mb-1">{payload?.[0]?.name}</p>
          <p className="data-text text-sm" style={{ color: payload?.[0]?.payload?.fill }}>
            {payload?.[0]?.value} agences ({payload?.[0]?.payload?.percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const totalAgencies = data?.reduce((sum, item) => sum + item?.value, 0);

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">
        {labels?.[currentLanguage]?.title}
      </h3>
      <div className="w-full h-64 md:h-80" aria-label="Subscription Distribution Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
              label={({ percentage }) => `${percentage}%`}
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[entry?.name] || 'var(--color-muted)'} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              wrapperStyle={{ fontSize: '12px' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">{labels?.[currentLanguage]?.total}</span>
          <span className="text-xl font-semibold text-foreground data-text">{totalAgencies}</span>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBreakdown;